// index.tsx
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { AppInitializer } from "./AppInitializer";

const rootElement = document.getElementById("root") as HTMLElement;
const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <AppInitializer />
  </React.StrictMode>
);

// Set RTL direction globally
document.dir = "rtl";

// Report performance
reportWebVitals();
